const encode = (dataObj) => Object.keys(dataObj)
  .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(dataObj[key])}`)
  .join('&');

const display = (item) => item.classList.add('show');
const hide = (item) => item.classList.remove('show');

const sendData = (data) => {
  const form = document.querySelector('form');
  const successMessage = document.getElementById('success');
  const errorMessage = document.getElementById('error');
  const fetchData = data;
  delete fetchData.terms;

  fetch('/', {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: encode(fetchData),
  })
    .then(() => {
      form.reset();
      form.addEventListener('change', () => hide(successMessage));
      display(successMessage);
    })
    .catch(() => {
      form.addEventListener('change', () => hide(errorMessage));
      display(errorMessage);
    });
};

export default sendData;
